'use strict'

import useMultiSite from '../../hooks/use-multi-site'

/**
 * Translate b2c link structure to our internal urls
 * @param {LinkStructure} linkStruct
 * @return {string}
 */
export function useUrlFromLink(linkStruct) {
    const {buildUrl} = useMultiSite()

    switch (linkStruct?.type) {
        case 'CATEGORY':
            return buildUrl(`/category/${linkStruct.target}`)
        case 'SEARCH':
            return buildUrl(`/search?q=${linkStruct.target}`)
        case 'PRODUCT':
            return buildUrl(`/product/${linkStruct.target}`)
        case 'PAGE':
            return buildUrl(`/page/${linkStruct.target}`)
        case 'EXTERNAL':
            if (linkStruct.target?.startsWith('/')) {
                // The url is marked as external but it's actually an internal route (e.g. /stores)
                return buildUrl(linkStruct.target)
            } else {
                return linkStruct.target
            }
    }
    return null
}

/**
 * Translate b2c link structure to our internal urls but not localized
 * @param {LinkStructure} linkStruct
 * @return {string}
 */
export function useUrlNotLocalizedFromLink(linkStruct) {
    switch (linkStruct?.type) {
        case 'CATEGORY':
            return `/category/${linkStruct.target}`
        case 'SEARCH':
            return `/search?q=${linkStruct.target}`
        case 'PRODUCT':
            return `/product/${linkStruct.target}`
        case 'PAGE':
            return `/page/${linkStruct.target}`
        case 'EXTERNAL':
            return linkStruct.target
    }
    return null
}
